// removed by extract-text-webpack-plugin
module.exports = {"xsmall":"only screen and (min-width: 375px)","small":"only screen and (min-width: 481px)","medium":"only screen and (min-width: 768px)","large":"only screen and (min-width: 993px)","xlarge":"only screen and (min-width: 1201px)","retina":"(-webkit-min-device-pixel-ratio: 2)","portrait":"only screen and (orientation: portrait)","landscape":"only screen and (orientation: landscape)","challengesWrapper":"challengesWrapper-1kcrt","challenges":"challenges-1Nw36","logoWrapper":"logoWrapper-1ECf6","logo":"logo-3bZsy","content":"content-14mPc","callToAction":"callToAction-3mgqq"};


//////////////////
// WEBPACK FOOTER
// ./src/components/landing/challenges/_challenges.css
// module id = 1223
// module chunks = 1